import { Link, Outlet, useLocation } from 'react-router-dom';
import { Link2, Smartphone, User, BookOpen, Star, Mail, Shield, FileSignature } from 'lucide-react';
import { usePendingApprovalCounts } from '@/lib/usePendingApprovalCounts';

export default function AdminSettings() {
  const location = useLocation();
  const counts = usePendingApprovalCounts();

  const tabs = [
    {
      id: 'integrations',
      path: '/admin-settings/integrations',
      label: 'Integrasjoner',
      icon: Link2,
      description: 'Administrer Xtramile-integrasjoner for dine medlemsorganisasjoner'
    },
    {
      id: 'literature-requests',
      path: '/admin-settings/literature-requests',
      label: 'Litteraturforespørsler',
      icon: Star,
      description: 'Godkjenn eller avvis forespørsler om kurerte kilder'
    },
    {
      id: 'email-domains',
      path: '/admin-settings/email-domains',
      label: 'E-postdomener',
      icon: Mail,
      description: 'Godkjenn eller avvis domeneforslag fra medlemsorganisasjoner',
      badge: counts.domains
    },
    {
      id: 'member-admin-requests',
      path: '/admin-settings/member-admin-requests',
      label: 'Admin-forespørsler',
      icon: Shield,
      description: 'Godkjenn eller avvis forespørsler om medlem-admin-rolle',
      badge: counts.adminRequests
    },
    {
      id: 'dpa',
      path: '/admin-settings/dpa',
      label: 'Databehandleravtaler',
      icon: FileSignature,
      description: 'Oversikt over signerte DPA-er og grace-perioder'
    },
    {
      id: 'devices',
      path: '/admin-settings/devices',
      label: 'Mine enheter',
      icon: Smartphone
    },
    {
      id: 'account',
      path: '/admin-settings/account',
      label: 'Konto',
      icon: User
    },
    {
      id: 'documentation',
      path: '/admin-settings/documentation',
      label: 'Dokumentasjon',
      icon: BookOpen
    },
  ];

  const currentPath = location.pathname;
  const activeTab = tabs.find(tab => currentPath.startsWith(tab.path))?.id || 'integrations';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Innstillinger</h1>
        <p className="mt-1 text-sm text-gray-500">
          Administrer innstillinger for ditt studieforbund
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow-sm border">
        <div className="border-b">
          <nav className="flex overflow-x-auto -mb-px whitespace-nowrap">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;

              const badge = (tab as any).badge as number | undefined;
              return (
                <Link
                  key={tab.id}
                  to={tab.path}
                  className={`px-3 sm:px-4 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 flex-shrink-0 ${
                    isActive
                      ? 'border-kf-primary text-kf-primary'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon size={18} />
                  {tab.label}
                  {badge !== undefined && badge > 0 && (
                    <span className="ml-1 inline-flex items-center justify-center px-2 py-0.5 text-xs font-bold rounded-full bg-red-500 text-white">
                      {badge}
                    </span>
                  )}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Content */}
      <Outlet />
    </div>
  );
}
